import {Component, Input} from '@angular/core';

// Бекенд (c_basket_data.php, pay()) тримає Redis-lock на користувача 60 секунд,
// щоб той не оформив кілька однакових замовлень поспіль, і на повторний запит
// відповідає помилкою «Order allready in progress.».
//
// Картка #258: раніше це був рядок дрібним текстом збоку від кнопки, його не помічали.
// Тепер - окремий блок з помаранчевою пунктирною рамкою НАД кнопкою «Відправити»
// і посиланням на список замовлень: попереднє замовлення, найімовірніше, вже створене,
// і його треба перевірити, а не відправляти ще раз.
@Component({
  selector: 'app-order-in-progress-message',
  template: `
    <div class="order-in-progress" *ngIf="show">
      <p class="order-in-progress__text">Попереднє замовлення ще обробляється. Повторне замовлення буде доступне через 60 сек.</p>
      <a class="order-in-progress__link" routerLink="/orders_history_new">Перейти до списку замовлень</a>
    </div>
  `,
  styles: [`
    :host {
      display: block;
    }

    .order-in-progress {
      box-sizing: border-box;
      width: 100%;
      // Картка #263: блок стояв впритул до посилання «Редагувати замовлення» над ним -
      // додаємо такий самий відступ зверху, як і знизу до кнопки «Відправити».
      margin: 12px 0;
      padding: 10px 14px;
      border: 1px dashed #FF8D33;
      background-color: #fdf6ef;
      font-family: 'Exo2Regular', sans-serif;
      font-size: 14px;
      line-height: 19px;
      color: #3b3b3b;
      text-align: left;
    }

    .order-in-progress__text {
      margin: 0;
    }

    .order-in-progress__link {
      display: inline-block;
      margin-top: 8px;
      font-family: 'Exo2Regular', sans-serif;
      font-size: 14px;
      color: #FF8D33;
      text-decoration: underline;
      cursor: pointer;
    }
  `]
})
export class OrderInProgressMessageComponent {
  @Input() show = false;
}
